import React, {useEffect, useState} from 'react';
import SideNavbar from '../../Components/SideNavbar';
import './CSS/Profile.css';
import {useNavigate} from "react-router-dom";

const Profile: React.FC = () => {
    const navigate = useNavigate();

    const [userName, setUserName] = useState<string | null>(null);
    const [userEmail, setUserEmail] = useState<string | null>(null);
    const [hasPassword, setHasPassword] = useState<boolean>(false);

    useEffect(() => {
        const storedName = localStorage.getItem('userName');
        const storedEmail = localStorage.getItem('userEmail');
        const storedHasPassword = localStorage.getItem('hasPassword') === 'true';

        setUserName(storedName);
        setUserEmail(storedEmail);
        setHasPassword(storedHasPassword);
    }, []);

    // const updatePreferences = () => {
    //     navigate('/account/preferences');
    // };

    const handlePasswordButtonClick = () => {
        if (hasPassword) {
            navigate('/account/update-password');
        } else {
            navigate('/account/create-password');
        }
    };

    return (
        <div className="profile-page">
            <SideNavbar />
            <div className="profile-content">
                <h1>Profile</h1>
                <div className="profile-section">
                    <div className="title-section">
                        <h2>Name</h2>
                        <button className="profile-update-btn">Update</button>
                    </div>
                    <div className="profile-row">
                        <span>{userName || 'No Name Available'}</span>
                    </div>
                </div>
                <div className="profile-section">
                    <h2>Email</h2>
                    <div className="profile-row">
                        <span>{userEmail || 'No Email Available'}</span>
                    </div>
                </div>
                <div className="profile-section">
                    <div className="title-section">
                        <h2>Password</h2>
                        <button className="profile-create-btn" onClick={handlePasswordButtonClick}>
                            {hasPassword ? 'Update' : 'Create'}
                        </button>
                    </div>
                </div>
                {/*<div className="profile-section">*/}
                {/*    <div className="title-section">*/}
                {/*        <h2>Email Preferences</h2>*/}
                {/*        <button className="profile-update-btn" onClick={updatePreferences}>Update preferences</button>*/}
                {/*    </div>*/}
                {/*    <p>Choose the types of emails you want to receive.</p>*/}
                {/*</div>*/}
                <div className="delete-section">
                    <button className="delete-account-btn">Delete Account</button>
                    <p>This account will no longer be available, and all your saved data will be permanently deleted.</p>
                </div>
            </div>
        </div>
    );
};

export default Profile;
